export default __webpack_public_path__ + "static/media/elastic-stack.01d5e2e6.png";